module.exports = __webpack_public_path__ + "favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./src/favicon.ico
// module id = 408
// module chunks = 0